function updateSlideOptions() {
  // Find all hotspot sections
  document.querySelectorAll('.image-hotspots').forEach(section => {
    const slidesData = section.dataset.slides;
    if (!slidesData) return;

    // Parse slides data
    const slides = slidesData.split(';')
      .filter(s => s)
      .map(slide => {
        const [id, number] = slide.split(',');
        return { value: id, label: `Slide ${number}` };
      });

    // Find all slide_id inputs in the theme editor
    const editor = document.querySelector('.theme-editor');
    if (!editor) return;

    // Look for select elements with name containing slide_id
    editor.querySelectorAll('select[name*="slide_id"]').forEach(select => {
      // Store current value
      const currentValue = select.value;

      // Clear existing options
      select.innerHTML = '';

      // Add default option
      const defaultOption = document.createElement('option');
      defaultOption.value = '';
      defaultOption.textContent = 'Select a slide';
      select.appendChild(defaultOption);

      // Add slide options
      slides.forEach(slide => {
        const option = document.createElement('option');
        option.value = slide.value;
        option.textContent = slide.label;
        select.appendChild(option);
      });

      // Restore selected value if it still exists
      if (slides.some(slide => slide.value === currentValue)) {
        select.value = currentValue;
      }
    });
  });
}

// Update when blocks are selected
document.addEventListener('shopify:block:select', updateSlideOptions);

// Update when sections are loaded
document.addEventListener('shopify:section:load', function() {
  // Find all slideshow components
  document.querySelectorAll('.slideshow').forEach(slideshow => {
    // Get all slides
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    
    // Initialize first slide
    if (slides.length > 0) {
      slides.forEach((slide, index) => {
        slide.style.display = index === 0 ? 'block' : 'none';
      });
    }
  });
});

// Also handle block select events
document.addEventListener('shopify:block:select', function(event) {
  const block = event.target;
  if (block.classList.contains('slideshow__slide')) {
    const slideshow = block.closest('.slideshow');
    const slides = slideshow.querySelectorAll('.slideshow__slide');
    slides.forEach(slide => slide.style.display = 'none');
    block.style.display = 'block';
  }
});

// Update when blocks are added
document.addEventListener('shopify:block:load', updateSlideOptions);

// Initial load
document.addEventListener('DOMContentLoaded', updateSlideOptions);

// Update when theme editor is ready
document.addEventListener('shopify:theme-editor:ready', updateSlideOptions);

// Additional event for theme editor interactions
document.addEventListener('page:loaded', updateSlideOptions);

class QuickAddButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onButtonClick.bind(this));
  }

  async onButtonClick() {
    const url = this.dataset.url;
    if (!url) return;

    // Add loading state
    this.classList.add('loading');
    
    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const productForm = html.querySelector('product-form');

      if (productForm) {
        // Trigger add to cart
        const submitButton = productForm.querySelector('[type="submit"]');
        if (submitButton) submitButton.click();
      }
    } catch (e) {
      console.error(e);
    } finally {
      // Remove loading state
      this.classList.remove('loading');
    }
  }
}

customElements.define('quick-add-button', QuickAddButton); 